import { createIcon } from '@chakra-ui/react';

export const CheckMark = createIcon({
  displayName: 'CheckMark',
  viewBox: '0 0 48 33.285',
  path: (
    <path
      id="CheckMark"
      data-name="CheckMark"
      d="M48,10.435a1.14,1.14,0,0,0-1.611,0L16.375,40.643,2.4,26.88A1.14,1.14,0,1,0,.842,28.5L15.585,43.059a1.155,1.155,0,0,0,.8.327,1.132,1.132,0,0,0,.806-.342L48,12.046a1.132,1.132,0,0,0,0-1.611Z"
      transform="translate(-0.341 -10.101)"
      fill="currentColor"
    />
  ),
});
